// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"Layout_page-layout__11U81","page-content":"Layout_page-content__2x7l1","footer-wrapper":"Layout_footer-wrapper__2f0as"};